// Hooks / Node modules / Styles
import {
  Header,
  useIsMobile,
  Drawer,
  DrawerToggler,
  useDrawer,
  Sidebar,
  HeaderNav,
} from "elseware-ui";

// Reducers / Actions

// Utils / Functions

// Components
import CustomBrand from "../custom-brand/CustomBrand";
// import UserLogPortal from "./_com/UserLogPortal";

// Sub-Components

// Data / Images / Icons
import {
  headerNavDesktopData,
  headerNavMobileData,
} from "../../../data/nav/header_nav";

function CustomHeader() {
  const isMobile = useIsMobile();
  const { show, openDrawer, closeDrawer } = useDrawer(false);

  return (
    <Header position="fixed" styles="w-full">
      <div className="flex flex-row items-center justify-between px-3 border-b border-b-secondary-500 bg-primary-500/70 backdrop-blur">
        <CustomBrand />
        {!isMobile && (
          <div className="flex flex-row items-center w-full justify-between px-3">
            <HeaderNav data={headerNavDesktopData} />
            {/* <UserLogPortal /> */}
          </div>
        )}
        {isMobile && (
          <DrawerToggler
            toggleDrawer={openDrawer}
            styles="text-secondary-500"
          />
        )}
      </div>

      {/* Sidebar */}
      <Drawer
        side="right"
        visibility={show}
        handleClose={closeDrawer}
        styles="bg-primary-500/70 backdrop-blur"
      >
        <Sidebar data={headerNavMobileData} />

        {/* <UserLogPortal /> */}
      </Drawer>
      {/* </div> */}
    </Header>
  );
}

export default CustomHeader;
